import { Injectable } from '@angular/core';

/**
 * One-shot latch for the attractions banner's first-reveal enlarge/crop animation.
 *
 * The banner plays its expand-and-settle reveal exactly once per page-session — the first time it
 * appears — and slides in normally on every appearance after that. A root singleton (like
 * `AttractionsEntryService`) is what makes "once" hold across scroll, dismiss and re-drop within a
 * page: the flag lives for the app's lifetime and re-arms only on a hard reload. It is deliberately
 * independent of the dismiss state.
 */
@Injectable({ providedIn: 'root' })
export class AttractionsBannerRevealService {
  private animated = false;

  /** Returns true the first time it is called this page-session, then false forever after. */
  shouldAnimateOnce(): boolean {
    if (this.animated) {
      return false;
    }
    this.animated = true;
    return true;
  }

  get hasPlayed(): boolean {
    return this.animated;
  }
}
